import { render, staticRenderFns } from "./DelayMessageModal.vue?vue&type=template&id=45420e1e&scoped=true&"
import script from "./DelayMessageModal.vue?vue&type=script&lang=js&"
export * from "./DelayMessageModal.vue?vue&type=script&lang=js&"
import style0 from "./DelayMessageModal.vue?vue&type=style&index=0&id=45420e1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45420e1e",
  null
  
)

export default component.exports